import { Dispatch, SetStateAction, useContext } from 'react'

import { JourneyContext } from '@/contexts/journey'
import { Step } from '@/types/step'

interface UseStepProps {
  currentStep: Step | undefined
  updateStep: (step: Step) => void
  setCurrentStep: Dispatch<SetStateAction<Step | undefined>>
}

export const useStep = (): UseStepProps => {
  const { currentStep, setCurrentStep } = useContext(JourneyContext)

  const updateStep = (step: Step) => {
    setCurrentStep(step)
  }

  return {
    currentStep,
    updateStep,
    setCurrentStep
  }
}
